<template>
	<div>
		<button
			:type="props.type"
			:class="[buttonClass, { 'icon-button': props.showIcon }]"
			:disabled="props.disabled"
		>
			<span
				v-if="props.showIcon"
				class="material-symbols-outlined notranslate"
				translate="no"
			>
				{{ props.icon }}
			</span>

			<span>
				{{ props.value }}
			</span>
		</button>
	</div>
</template>

<script setup>
import { defineProps, computed } from 'vue'

const props = defineProps({
	type: String,
	value: String,
	// primary (red), outline, no-border
	variant: String,
	size: {
		type: String,
		default: 'xl',
		validator: (value) => ['xl', 'lg', 'md', 'sm'].includes(value),
	},
	showIcon: {
		type: Boolean,
		default: false,
	},
	icon: {
		type: String,
		default: 'replay',
	},
	disabled: {
		type: Boolean,
		default: false,
	},
})

const buttonClass = computed(() => {
	let classes = [`tv__btn-${props.variant}`]
	classes += ` tv__btn-${props.size}`
	return classes
})
</script>
